// extracted by mini-css-extract-plugin
module.exports = {"catagory-list":"Catagorical_catagory-list__2hwLA"};